import {
  OmsCustomerNameConditionStep,
  OmsCustomerTagConditionStep,
  OmsCustomString1ConditionStep,
  OmsDeliveryMethodConditionStep,
  OmsDestinationCountryConditionStep,
  OmsDestinationProvinceConditionStep,
  OmsFraudRiskConditionStep,
  OmsFulfillmentLocationConditionStep,
  OmsLineItemCustomAttributeConditionStep,
  OmsOrderTagConditionStep,
  OmsOriginStoreConditionStep,
  OmsProductNameConditionStep,
  OmsProductTagConditionStep,
  OmsProductTypeConditionStep,
  OmsSalesChannelConditionStep,
  OmsSelectedShippingConditionStep,
  OmsShipmentTagConditionStep,
  OmsSkuConditionStep,
  OmsStreetAddressListInputConditionStep,
  OmsUspsZoneConditionStep,
  OmsVariantTitleConditionStep,
  OmsVendorConditionStep,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { memo } from "react";
import { DeepPartial } from "..";
import { ListMatchValuesInput } from "../common/list-match-values-input";

export const OmsListMatchValuesInput = memo(
  function ListToListMatchValuesInput({
    step,
    setStep,
    tagInputPlaceholder,
    addTagText,
    optionsFetcher,
    preserveCommas,
  }: {
    step:
      | DeepPartial<OmsOrderTagConditionStep>
      | DeepPartial<OmsSkuConditionStep>
      | DeepPartial<OmsSelectedShippingConditionStep>
      | DeepPartial<OmsProductNameConditionStep>
      | DeepPartial<OmsVariantTitleConditionStep>
      | DeepPartial<OmsProductTypeConditionStep>
      | DeepPartial<OmsDestinationProvinceConditionStep>
      | DeepPartial<OmsDestinationCountryConditionStep>
      | DeepPartial<OmsDeliveryMethodConditionStep>
      | DeepPartial<OmsSalesChannelConditionStep>
      | DeepPartial<OmsProductTagConditionStep>
      | DeepPartial<OmsFulfillmentLocationConditionStep>
      | DeepPartial<OmsOriginStoreConditionStep>
      | DeepPartial<OmsFraudRiskConditionStep>
      | DeepPartial<OmsStreetAddressListInputConditionStep>
      | DeepPartial<OmsShipmentTagConditionStep>
      | DeepPartial<OmsCustomString1ConditionStep>
      | DeepPartial<OmsCustomerNameConditionStep>
      | DeepPartial<OmsUspsZoneConditionStep>
      | DeepPartial<OmsVendorConditionStep>
      | DeepPartial<OmsLineItemCustomAttributeConditionStep>
      | DeepPartial<OmsCustomerTagConditionStep>;
    setStep: (step: DeepPartial<OmsConditionStep>) => void;
    tagInputPlaceholder: string;
    addTagText?: string;
    optionsFetcher: ({
      searchText,
    }: {
      searchText: string;
    }) => Promise<string[]>;
    preserveCommas?: boolean;
  }) {
    return (
      <ListMatchValuesInput
        addTagText={addTagText}
        matchValues={step.matchValues}
        onMatchValuesChange={(matchValues) => {
          setStep({ ...step, matchValues } as DeepPartial<OmsConditionStep>);
        }}
        optionsFetcher={optionsFetcher}
        preserveCommas={preserveCommas}
        tagInputPlaceholder={tagInputPlaceholder}
      />
    );
  },
);
